import Vue from 'vue';
import VueRouter from 'vue-router';
import { routerHelpers } from '@codehq/aurora-app-core';

import modules from '../modules';

const AuthHome = () => import(/* webpackChunkName: "route-AuthHome" */'../views/AuthHome.vue');
const ChangePassword = () => import(/* webpackChunkName: "route-ChangePassword" */'../views/ChangePassword.vue');
const ErrorPage = () => import(/* webpackChunkName: "route-ErrorPage" */'../views/ErrorPage.vue');
const Welcome = () => import(/* webpackChunkName: "route-Welcome" */'../views/Welcome.vue');
const Logoff = () => import(/* webpackChunkName: "route-Logoff" */'../views/Logoff.vue');
const UserManagementHome = () => import(/* webpackChunkName: "route-Logoff" */'../views/UserManagementHome.vue');
const PasswordReset = () => import(/* webpackChunkName: "route-Logoff" */'../views/PasswordReset.vue');
const Terms = () => import(/* webpackChunkName: "route-Terms" */'../views/Terms.vue');
const AdminAuth = () => import(/* webpackChunkName: "route-Terms" */'../views/AdminAuth.vue');
const Radio = () => import(/* webpackChunkName: "route-Radio" */'../views/Radio.vue');

Vue.use(VueRouter);

const appRoutes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
  },
  {
    path: '/admin/auth',
    name: 'AdminAuth',
    component: AdminAuth,
  },
  {
    path: '/policy/tos',
    name: 'Terms',
    component: Terms,
  },
  {
    path: '/home',
    name: 'AuthHome',
    component: AuthHome,
  },
  {
    path: '/radio',
    name: 'Radio',
    component: Radio,
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
  },
  {
    path: '/auth/logoff',
    name: 'auth-Logoff',
    component: Logoff,
  },
  {
    path: '/auth/password-reset',
    name: 'auth-PasswordReset',
    component: PasswordReset,
  },
  {
    path: '/auth/change-password',
    name: 'auth-ChangePassword',
    component: ChangePassword,
  },
  {
    path: '/membership/user-management-home',
    name: 'membership-UserManagementHome',
    component: UserManagementHome,
  },
];

const moduleRoutes = modules.map((m) => routerHelpers.mapViews(m.config.path, m.views));

const routes = [...appRoutes, ...moduleRoutes.flat()];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    const isLoggedIn = router.app.$store.getters['auth/isLoggedIn'];
    if (isLoggedIn) {
      await router.app.$store.dispatch('auth/REFRESH_auth');
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    next();
  }
});

export { routes };
export { router };
